import { ChoiceGroup } from '@consta/uikit/ChoiceGroup'
import { Select } from '@consta/uikit/Select'
import { Text } from '@consta/uikit/Text'
import type { TextFieldProps } from '@consta/uikit/TextField'
import { TextField } from '@consta/uikit/TextField'
import { getVelocityModelsByActiveProject, useAppDispatch } from '@core/core/store'
import type { VelocityModel } from '@core/core/types'
import type { Nullable } from 'common/types'
import type { FC } from 'react'
import { useEffect } from 'react'

import { modelMenuChoiceItems } from '../constants'
import type { NavBarChoiceItemsType } from '../types'
import type { ModelMenuProps } from './types'
import css from './VelocitySimulationRightMenu.css'

const textFieldProps: TextFieldProps<string> = {
  size: 'xs',
  withClearButton: true,
  className: `${css.modelMenuSelect} ${css.textField}`,
}

export const ModelMenu: FC<ModelMenuProps> = ({
  existingModelsList: modelsList,
  chosenVelocityModel: velocityModel,
  onChangeVelocityModel,
  choiceValue,
  setChoiceValue,
  modelName,
  setFormData,
}) => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(getVelocityModelsByActiveProject())
  }, [])

  const onChangeModelName = (value: Nullable<string>) => {
    setFormData(prev => ({
      ...prev,
      model: {
        name: value ?? '',
      },
    }))
  }

  const currentModelEntity = () => {
    switch (choiceValue.model) {
      case modelMenuChoiceItems[0]: {
        return (
          <div className={css.entityName}>
            <Text size="xs" lineHeight="2xs" view="secondary" className={css.entityNameText}>
              Название
            </Text>
            <TextField {...textFieldProps} value={modelName} onChange={onChangeModelName} />
          </div>
        )
      }
      case modelMenuChoiceItems[1]:
        return (
          <div>
            <Select
              label="Выберите модель"
              placeholder="Выберите модель из списка"
              items={modelsList}
              value={velocityModel}
              getItemLabel={({ name }) => name}
              getItemKey={({ id }: VelocityModel) => id}
              labelForEmptyItems="Список моделей пока пуст"
              size="xs"
              className={`${css.modelMenuSelect} ${css.modelSelect}`}
              onChange={onChangeVelocityModel}
            />
          </div>
        )

      default:
        return null
    }
  }

  const onNavigate = (value: NavBarChoiceItemsType) => {
    setChoiceValue(prevState => ({ ...prevState, model: value }))
  }

  return (
    <div className={css.wrapper}>
      <ChoiceGroup
        size="xs"
        view="ghost"
        value={choiceValue.model}
        items={modelMenuChoiceItems}
        getItemLabel={({ name }) => name}
        multiple={false}
        getItemDisabled={({ disabled }) => disabled}
        name="sortGroup"
        className={css.rightMenuChoiceGroup}
        onChange={onNavigate}
      />
      {currentModelEntity()}
    </div>
  )
}
